var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternal(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    width: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M1.437 3.188h3.938v.875h-3.5v10.062h8.312V9.312h.875v5.25a.437.437 0 01-.437.438H1.437A.437.437 0 011 14.562V3.625c0-.242.196-.437.437-.437zm10.5-.64v1.077a.437.437 0 01-.437.438c-2.685 0-4.326.945-4.877 2.81l-.076.329.714-.634c1.37-1.103 2.786-1.193 4.239-1.193.242 0 .437.196.437.438V6.89l2.027-2.171zM11.5 1c.119 0 .235.049.32.139l3.062 3.281a.438.438 0 010 .598l-3.062 3.28A.439.439 0 0111.062 8V6.254c-1.165.022-2.228.17-3.236.982L6.103 8.765a.435.435 0 01-.514.048.438.438 0 01-.203-.474l.391-1.69c.452-1.531 1.735-3.318 5.285-3.453V1.438A.438.438 0 0111.5 1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default ForwardRef;